const actionTypes = {
  SET_USER: 'SET_USER',
  CHECK_USER: 'CHECK_USER',
  ADD_CAR: 'ADD_CAR',
  BOOK_CAR: 'BOOK_CAR',
  SELECT_CAR: 'SELECT_CAR',
  ADD_RECENT_CAR: 'ADD_RECENT_CAR',
};

export default actionTypes;
